import { HOME_PLAN_ID_FOR_USER_CREATION, RemoteConfigVariables } from 'fitbeat.models';
import { remoteConfigDefaults } from './FirebaseRemoteConfigDefaults';
import { getConfig } from '../config';

export class FirebaseRemoteConfig {
    static setRemoteConfigDefaults = async () => {
        // not implemented
    }

    static forceReloadRemoteConfigValues = async () => {
        // not implemented
    }

    static getRemoteConfigValue = async (configKey) => {
        const config = getConfig();
        const environment = config.gymEnvironment;

        return Object.keys(remoteConfigDefaults)
            .filter((key) => {
                if (key === configKey || key === `${configKey}_${environment}`) {
                    return true;
                }
            })
            .reduce((a, b) => remoteConfigDefaults[b], '');
    }

    static abExperimentVariantEnabled = async (key, variant) => {
        const valueFromConfig = await FirebaseRemoteConfig.getRemoteConfigValue(key);
        return valueFromConfig === variant;
    }
}
